import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const axi = axios.create({ baseURL: API, withCredentials: true });

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

/**
 * AuthProvider — bootstraps the session on mount by calling /auth/me.
 * user === undefined  → still checking (show splash)
 * user === null       → not authenticated (show login)
 * user === {...}      → authenticated (show app)
 */
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);

  const check = useCallback(async () => {
    try {
      const { data } = await axi.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = useCallback(async (username, passcode) => {
    const { data } = await axi.post("/auth/login", { username, passcode });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await axi.post("/auth/logout"); } catch {}
    setUser(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, login, logout, refresh: check }}>
      {children}
    </AuthCtx.Provider>
  );
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
